import { useRemoteNavigation } from "../../contexts/RemoteNavigationContext";
import { useEffect } from "react";
import InteractiveComponent from "./InteractiveComponent";
import { LOGS } from "../../utils/logging";
import UserProfile from "./ProfileMenu";
import { SceneComponent, UserProfileMenuConfig } from "../../../config/interactive/types";
import { SceneComponentSchema } from "../../../config/schemas";
import { getParseData, isValidParse } from "../../utils/zodUtils";
import { selectId, selectInitialFocus } from "../../../config/interactive/utils";
import { useFade } from "../../hooks/useFade";

interface Props {
	sceneInteractives: SceneComponent[];
	focusedId: string;
}

function InteractiveMenu({ sceneInteractives, focusedId }: Props) {
	const { setFocus } = useRemoteNavigation();
	const { fadeStyles, isFaded } = useFade();

	const validatedInteractivesData = (sceneInteractives ?? [])
		.map((config) => SceneComponentSchema.safeParse(config))
		.filter(isValidParse)
		.map(getParseData);

	const InteractiveComponents = validatedInteractivesData
		.filter((config) => !config.isUserProfile)
		.map((config) => (
			<InteractiveComponent
				key={config.navigation.id}
				src={config.src}
				position={config.position}
				navigation={config.navigation}
				verbs={config.verbs}
				isProtected={config.protected}
				hoveredSrc={config.hoveredSrc}
				isFocused={focusedId === config.navigation.id}
				isFaded={isFaded}
			/>
		));

	useEffect(() => {
		const initialFocusComponent = validatedInteractivesData.find(selectInitialFocus);
		if (!initialFocusComponent) {
			console.error("No initial focused element marked in config for scene");
			return;
		}
		const focusId = selectId(initialFocusComponent);
		LOGS.INTERACTIVE && console.info("setting initialfocus id to:", focusId);
		setFocus(focusId);
	}, [sceneInteractives]);

	// TODO: TEMP this schema doesn't accurately match fix SceneComponent schema
	const userProfileComponent = sceneInteractives.find((el) => el.isUserProfile);
	const userProfile: UserProfileMenuConfig = userProfileComponent?.isUserProfile
		? { isUserProfile: true, navigation: userProfileComponent.navigation }
		: { isUserProfile: false };
	return (
		<>
			<UserProfile config={userProfile} />
			<div style={fadeStyles}>{InteractiveComponents}</div>
		</>
	);
}

export default InteractiveMenu;
